(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchModal = this.querySelector('details-modal');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.searchModal && this.searchModal.isOpen()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.searchModal && this.searchModal.isOpen()) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-whisker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getGalleryInputs = (gallery) => Array.from(gallery.querySelectorAll('[data-product-whisker-gallery-input]'));
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateGalleryControls = (gallery, activeIndex, count) => {
      gallery.querySelectorAll('[data-product-whisker-gallery-control]').forEach((control) => {
        const direction = control.dataset.productWhiskerGalleryControl === 'previous' ? -1 : 1;
        const isDisabled = direction < 0 ? activeIndex <= 0 : activeIndex >= count - 1;

        control.disabled = isDisabled;
        control.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      });
    };

    const syncGalleryVideos = (gallery, activeIndex) => {
      gallery.querySelectorAll('[data-product-whisker-gallery-card]').forEach((card, index) => {
        card.querySelectorAll('.product-whisker__media-video').forEach((video) => {
          if (index === activeIndex) {
            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;
            video.playsInline = true;

            if (!prefersReducedMotion()) {
              video.play().catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      });
    };

    const getThumbViewport = (gallery) => gallery.querySelector('[data-product-whisker-thumbs]');

    const getThumbScrollStep = (gallery) => {
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-whisker-gallery-thumb]'));

      if (thumbs.length > 1) {
        return Math.max(thumbs[1].offsetTop - thumbs[0].offsetTop, thumbs[0].offsetHeight);
      }

      return thumbs[0] ? thumbs[0].offsetHeight : 120;
    };

    const updateThumbnailControls = (gallery) => {
      const viewport = getThumbViewport(gallery);

      if (!viewport) return;

      const maxScroll = Math.max(0, viewport.scrollHeight - viewport.clientHeight);
      const scrollTop = Math.max(0, viewport.scrollTop);

      gallery.querySelectorAll('[data-product-whisker-thumb-control]').forEach((control) => {
        const direction = control.dataset.productWhiskerThumbControl === 'previous' ? -1 : 1;
        const isDisabled = direction < 0 ? scrollTop <= 2 : scrollTop >= maxScroll - 2;

        control.disabled = isDisabled;
        control.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      });
    };

    const pulseThumbControl = (gallery, control, direction) => {
      const rail = gallery.querySelector('[data-product-whisker-thumb-rail]');

      if (rail) {
        const motion = direction > 0 ? 'next' : 'previous';
        rail.dataset.thumbMotion = motion;
        window.setTimeout(() => {
          if (rail.dataset.thumbMotion === motion) {
            delete rail.dataset.thumbMotion;
          }
        }, 260);
      }

      control.classList.remove('product-whisker__thumb-nav--pulse');
      void control.offsetWidth;
      control.classList.add('product-whisker__thumb-nav--pulse');
      window.setTimeout(() => control.classList.remove('product-whisker__thumb-nav--pulse'), 260);
    };

    const syncGalleryState = (gallery, input, options = {}) => {
      const inputs = getGalleryInputs(gallery);
      const activeIndex = inputs.indexOf(input);

      if (activeIndex < 0) return;

      const track = gallery.querySelector('[data-product-whisker-gallery-track]');

      if (track) {
        track.style.setProperty('--pw-gallery-index', activeIndex);
      }

      gallery.querySelectorAll('[data-product-whisker-gallery-thumb]').forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      gallery.querySelectorAll('[data-product-whisker-gallery-card]').forEach((card, index) => {
        if (index === activeIndex) {
          card.removeAttribute('aria-hidden');
        } else {
          card.setAttribute('aria-hidden', 'true');
        }
      });

      syncGalleryVideos(gallery, activeIndex);
      updateGalleryControls(gallery, activeIndex, inputs.length);

      if (options.scrollThumb) {
        scrollActiveThumbIntoView(gallery, input);
      }
    };

    const scrollActiveThumbIntoView = (gallery, input) => {
      const thumb = Array.from(gallery.querySelectorAll('.product-whisker__thumb')).find((candidate) => candidate.htmlFor === input.id);

      if (!thumb) return;

      thumb.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    };

    const setLightboxSlide = (lightbox, mediaId) => {
      const slides = Array.from(lightbox.querySelectorAll('[data-product-whisker-lightbox-slide]'));
      let activeIndex = slides.findIndex((slide) => slide.dataset.productWhiskerLightboxMediaId === mediaId);

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;

        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      [activeIndex - 1, activeIndex, activeIndex + 1].forEach((index) => {
        const image = slides[index] ? slides[index].querySelector('img') : null;

        if (image) {
          image.loading = 'eager';
        }
      });

      lightbox.dataset.activeIndex = String(activeIndex);
      lightbox.querySelectorAll('[data-product-whisker-lightbox-control]').forEach((control) => {
        const isPrevious = control.dataset.productWhiskerLightboxControl === 'previous';
        const isDisabled = isPrevious ? activeIndex <= 0 : activeIndex >= slides.length - 1;

        control.disabled = isDisabled;
        control.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      });
    };

    const moveLightboxSlide = (lightbox, direction) => {
      const slides = Array.from(lightbox.querySelectorAll('[data-product-whisker-lightbox-slide]'));
      const activeIndex = Number.parseInt(lightbox.dataset.activeIndex || '0', 10);
      const nextIndex = Math.min(slides.length - 1, Math.max(0, activeIndex + direction));

      if (!slides[nextIndex] || nextIndex === activeIndex) return;

      setLightboxSlide(lightbox, slides[nextIndex].dataset.productWhiskerLightboxMediaId);
    };

    const setupLightbox = (gallery) => {
      const overview = gallery.closest('.product-whisker__overview');
      const lightbox = overview ? overview.querySelector('[data-product-whisker-lightbox]') : null;

      if (!lightbox) return;

      let activeTrigger = null;

      gallery.querySelectorAll('[data-product-whisker-lightbox-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          activeTrigger = trigger;
          setLightboxSlide(lightbox, trigger.dataset.productWhiskerLightboxMediaId);
          document.body.classList.add('product-whisker-lightbox-open');
          lightbox.showModal();
        });
      });

      lightbox.querySelector('[data-product-whisker-lightbox-close]').addEventListener('click', () => {
        lightbox.close();
      });

      lightbox.querySelectorAll('[data-product-whisker-lightbox-control]').forEach((control) => {
        control.addEventListener('click', () => {
          const direction = control.dataset.productWhiskerLightboxControl === 'previous' ? -1 : 1;
          moveLightboxSlide(lightbox, direction);
        });
      });

      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) {
          lightbox.close();
        }
      });

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveLightboxSlide(lightbox, -1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveLightboxSlide(lightbox, 1);
        }
      });

      lightbox.addEventListener('close', () => {
        document.body.classList.remove('product-whisker-lightbox-open');

        if (activeTrigger) {
          activeTrigger.focus();
        }
      });
    };

    document.querySelectorAll('[data-product-whisker-gallery]').forEach((gallery) => {
      const checkedInput = getGalleryInputs(gallery).find((input) => input.checked);

      if (checkedInput) {
        syncGalleryState(gallery, checkedInput);
      }

      updateThumbnailControls(gallery);

      const thumbViewport = getThumbViewport(gallery);

      if (thumbViewport) {
        let pendingThumbUpdate = false;

        thumbViewport.addEventListener('scroll', () => {
          if (pendingThumbUpdate) return;

          pendingThumbUpdate = true;
          window.requestAnimationFrame(() => {
            updateThumbnailControls(gallery);
            pendingThumbUpdate = false;
          });
        });

        window.addEventListener('resize', () => updateThumbnailControls(gallery));
      }

      setupLightbox(gallery);
    });

    const setupSpecAccordion = (accordion) => {
      const specPanel = accordion.closest('.product-whisker__spec-panel');
      const visualGroup = specPanel ? specPanel.querySelector('[data-product-whisker-spec-visuals]') : null;
      const specDetails = Array.from(accordion.querySelectorAll('[data-product-whisker-spec-details]'));
      const visualPanels = visualGroup ? Array.from(visualGroup.querySelectorAll('[data-product-whisker-spec-visual]')) : [];

      const syncSpecVisual = () => {
        if (!visualGroup || visualPanels.length === 0) return;

        const activeDetails = specDetails.find((details) => details.open) || specDetails[0];
        const activeId = activeDetails ? activeDetails.dataset.productWhiskerSpecDetails : '';

        visualPanels.forEach((panel) => {
          const isActive = panel.dataset.productWhiskerSpecVisual === activeId;

          panel.classList.toggle('product-whisker__spec-visual-panel--active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      specDetails.forEach((details) => {
        details.addEventListener('toggle', () => {
          window.requestAnimationFrame(syncSpecVisual);
        });
      });

      if (accordion.dataset.singleOpen !== 'false') {
        accordion.addEventListener('click', (event) => {
          const summary = event.target.closest('summary');

          if (!summary || !accordion.contains(summary)) return;

          const current = summary.closest('details');

          if (!current) return;

          if (!current.open) {
            accordion.querySelectorAll('details[open]').forEach((details) => {
              if (details !== current) {
                details.open = false;
              }
            });
          }
        });
      }

      syncSpecVisual();
    };

    document.querySelectorAll('[data-product-whisker-spec-accordion]').forEach(setupSpecAccordion);

      const setupStickyNavigation = (sticky) => {
        const root = sticky.closest('.product-whisker');
        const sentinel = root ? root.querySelector('[data-product-whisker-sticky-sentinel]') : null;
        const links = Array.from(sticky.querySelectorAll('.product-whisker__sticky-link'));
        const linksContainer = sticky.querySelector('.product-whisker__sticky-links');
      const globalHeader = document.querySelector('sticky-header');

      if (!root || !sentinel || links.length === 0) return;

      let previousScrollTop = window.scrollY;
      let pendingUpdate = false;
      let activeHref = '';

      const getTarget = (link) => {
        const href = link.getAttribute('href');

        if (!href || !href.startsWith('#')) return null;

        return document.getElementById(href.slice(1));
      };

      const syncActiveLink = () => {
        const stickyHeight = sticky.offsetHeight;
        const activationLine = window.scrollY + stickyHeight + 32;
        let activeLink = links[0];

        links.forEach((link) => {
          const target = getTarget(link);

          if (target && target.getBoundingClientRect().top + window.scrollY <= activationLine) {
            activeLink = link;
          }
        });

        const nextHref = activeLink.getAttribute('href') || '';

        links.forEach((link) => {
          const isActive = link === activeLink;
          link.classList.toggle('product-whisker__sticky-link--active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        if (linksContainer && nextHref !== activeHref) {
          const left = activeLink.offsetLeft - (linksContainer.clientWidth - activeLink.offsetWidth) / 2;
          linksContainer.scrollTo({
            left: Math.max(0, left),
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          });
        }

        activeHref = nextHref;
      };

        const updateStickyState = () => {
          const scrollTop = window.scrollY;
          const delta = scrollTop - previousScrollTop;
          const stickyStart = sentinel.getBoundingClientRect().top + scrollTop;
          const rootBottom = root.getBoundingClientRect().bottom + scrollTop;
          const stickyHeight = sticky.offsetHeight;
          const isStickyRange = scrollTop >= stickyStart && scrollTop < rootBottom - stickyHeight;

          sticky.dataset.productWhiskerStickyReady = 'true';
          sticky.classList.toggle('product-whisker__sticky--is-active', isStickyRange);

          if (isStickyRange) {
            if (globalHeader) {
              globalHeader.dispatchEvent(new Event('preventHeaderReveal'));

              if (typeof globalHeader.hide === 'function') {
                globalHeader.hide();
              }
            }
          } else if (globalHeader) {
            globalHeader.preventReveal = false;

            if (delta < -4 && typeof globalHeader.reveal === 'function') {
              window.requestAnimationFrame(() => globalHeader.reveal());
            }
          }

          syncActiveLink();
          previousScrollTop = scrollTop;
          pendingUpdate = false;
        };

      links.forEach((link) => {
        link.addEventListener('click', () => {
          const href = link.getAttribute('href') || '';
          activeHref = href;
          links.forEach((candidate) => {
            const isActive = candidate === link;
            candidate.classList.toggle('product-whisker__sticky-link--active', isActive);

            if (isActive) {
              candidate.setAttribute('aria-current', 'location');
            } else {
              candidate.removeAttribute('aria-current');
            }
          });
        });
      });

      window.addEventListener(
        'scroll',
        () => {
          if (pendingUpdate) return;

          pendingUpdate = true;
          window.requestAnimationFrame(updateStickyState);
        },
        { passive: true }
      );
      window.addEventListener('resize', updateStickyState);
      updateStickyState();
    };

    document.querySelectorAll('[data-product-whisker-sticky-nav]').forEach(setupStickyNavigation);

    const setupDetailRails = (root = document) => {
      root.querySelectorAll('[data-product-whisker-detail-rail]').forEach((rail) => {
        if (rail.dataset.productWhiskerDetailRail === 'ready') return;

        rail.dataset.productWhiskerDetailRail = 'ready';

        if (rail.dataset.dragEnabled !== 'true') return;

        let isPointerDown = false;
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        const stopDrag = () => {
          if (!isPointerDown) return;

          isPointerDown = false;
          rail.classList.remove('product-whisker__detail-cards--dragging');

          window.setTimeout(() => {
            isDragging = false;
          }, 0);
        };

        rail.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 || event.pointerType === 'touch') return;

          isPointerDown = true;
          isDragging = false;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
          rail.classList.add('product-whisker__detail-cards--dragging');
          rail.setPointerCapture(event.pointerId);
        });

        rail.addEventListener('pointermove', (event) => {
          if (!isPointerDown) return;

          const delta = event.clientX - startX;

          if (Math.abs(delta) > 3) {
            isDragging = true;
          }

          rail.scrollLeft = startScrollLeft - delta;
          event.preventDefault();
        });

        rail.addEventListener('pointerup', stopDrag);
        rail.addEventListener('pointercancel', stopDrag);
        rail.addEventListener('mouseleave', stopDrag);
        rail.addEventListener(
          'click',
          (event) => {
            if (!isDragging) return;

            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
      });
    };

    setupDetailRails();

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncStoryVideoVisibility = (video, isVisible) => {
      const media = video.closest('.product-whisker__story-media');

      video.classList.toggle('product-whisker__story-video--visible', isVisible);

      if (media) {
        media.classList.toggle('product-whisker__story-media--video-visible', isVisible);
      }
    };

    const markStoryVideoReady = (video) => {
      if (video.readyState < 2) return;

      video.classList.add('product-whisker__story-video--ready');
    };

    const shouldAutoplayStoryVideo = (video) => {
      return video.dataset.productWhiskerStoryAutoplay === 'true';
    };

    const isStoryVideoPlayable = (video) => {
      return (
        video.dataset.productWhiskerStoryInView === 'true' &&
        shouldAutoplayStoryVideo(video) &&
        !video.controls &&
        !reducedMotionQuery.matches
      );
    };

    const revealStoryVideo = (video) => {
      video.dataset.productWhiskerStoryRevealPending = 'false';
      markStoryVideoReady(video);
      syncStoryVideoVisibility(video, true);
    };

    const sampleStoryVideoFrame = (video) => {
      if (!video.videoWidth || !video.videoHeight) {
        return { canSample: false, isUsable: false };
      }

      const canvas = video.productWhiskerStoryCanvas || document.createElement('canvas');
      const context =
        video.productWhiskerStoryContext || canvas.getContext('2d', { willReadFrequently: true });

      if (!context) {
        return { canSample: false, isUsable: true };
      }

      video.productWhiskerStoryCanvas = canvas;
      video.productWhiskerStoryContext = context;
      canvas.width = 72;
      canvas.height = 40;

      try {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let lumaTotal = 0;
        let alphaTotal = 0;
        let blackPixels = 0;
        const pixelCount = pixels.length / 4;

        for (let index = 0; index < pixels.length; index += 4) {
          const red = pixels[index];
          const green = pixels[index + 1];
          const blue = pixels[index + 2];
          const alpha = pixels[index + 3];
          const luma = 0.2126 * red + 0.7152 * green + 0.0722 * blue;

          lumaTotal += luma;
          alphaTotal += alpha;

          if (luma < 12) {
            blackPixels += 1;
          }
        }

        const averageLuma = lumaTotal / pixelCount;
        const averageAlpha = alphaTotal / pixelCount;
        const blackRatio = blackPixels / pixelCount;

        return {
          canSample: true,
          isUsable: averageAlpha > 180 && averageLuma > 18 && blackRatio < 0.86,
          averageLuma,
          blackRatio
        };
      } catch (error) {
        return { canSample: false, isUsable: true };
      }
    };

    const waitForStoryVideoEvent = (video, eventName, timeout = 4000) => {
      return new Promise((resolve) => {
        const timer = window.setTimeout(() => cleanup(), timeout);
        const cleanup = () => {
          window.clearTimeout(timer);
          video.removeEventListener(eventName, cleanup);
          video.removeEventListener('error', cleanup);
          resolve();
        };

        video.addEventListener(eventName, cleanup, { once: true });
        video.addEventListener('error', cleanup, { once: true });
      });
    };

    const seekStoryVideo = async (video, time) => {
      if (!Number.isFinite(time) || Math.abs(video.currentTime - time) < 0.05) return;

      try {
        video.currentTime = Math.max(0, Math.min(time, video.duration || time));
      } catch (error) {
        return;
      }

      await waitForStoryVideoEvent(video, 'seeked', 2500);
    };

    const loadStoryVideo = (video, eager = false) => {
      const nextPreload = eager ? 'auto' : 'metadata';

      if (video.preload !== nextPreload) {
        video.setAttribute('preload', nextPreload);
        video.preload = nextPreload;
      }

      if (video.dataset.productWhiskerStoryLoaded === 'true') return;

      video.dataset.productWhiskerStoryLoaded = 'true';

      if (video.readyState < 1) {
        video.load();
      }
    };

    const findStoryVideoVisibleStart = (video) => {
      const cachedStart = Number(video.dataset.productWhiskerStoryClipStart);

      if (Number.isFinite(cachedStart)) {
        return Promise.resolve(cachedStart);
      }

      if (video.productWhiskerStoryScanPromise) {
        return video.productWhiskerStoryScanPromise;
      }

      video.productWhiskerStoryScanPromise = (async () => {
        loadStoryVideo(video, true);

        if (video.readyState < 1) {
          await waitForStoryVideoEvent(video, 'loadedmetadata', 6000);
        }

        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        const scanTimes = [0.08, 0.5, 1, 2, 3, 4, 5, 6, 8, 10, 12, 15, 18, 20, 24, 28, 30, 34, 38, 42];
        const candidates = scanTimes.filter((time) => !duration || time < duration - 0.4);

        for (const time of candidates) {
          await seekStoryVideo(video, time);
          await new Promise((resolve) => window.setTimeout(resolve, 90));

          const frame = sampleStoryVideoFrame(video);

          if (!frame.canSample || frame.isUsable) {
            video.dataset.productWhiskerStoryClipStart = String(time);
            return time;
          }
        }

        video.dataset.productWhiskerStoryHasUsableFrame = 'false';
        return null;
      })();

      return video.productWhiskerStoryScanPromise;
    };

    const resetStoryVideoToClipStart = async (video) => {
      const clipStart = Number(video.dataset.productWhiskerStoryClipStart);

      if (!Number.isFinite(clipStart)) return;

      syncStoryVideoVisibility(video, false);
      await seekStoryVideo(video, clipStart);
    };

    const queueStoryVideoFrameMonitor = (video) => {
      if (video.dataset.productWhiskerStoryFrameMonitor === 'true') return;

      video.dataset.productWhiskerStoryFrameMonitor = 'true';

      const tick = async () => {
        video.dataset.productWhiskerStoryFrameMonitor = 'false';

        if (!isStoryVideoPlayable(video) || video.paused) return;

        const frame = sampleStoryVideoFrame(video);

        if (!frame.canSample || frame.isUsable) {
          video.dataset.productWhiskerStoryBlackFrames = '0';
          revealStoryVideo(video);
        } else {
          const blackFrames = Number(video.dataset.productWhiskerStoryBlackFrames || '0') + 1;

          video.dataset.productWhiskerStoryBlackFrames = String(blackFrames);
          syncStoryVideoVisibility(video, false);

          if (blackFrames >= 2) {
            video.dataset.productWhiskerStoryBlackFrames = '0';
            await resetStoryVideoToClipStart(video);

            if (isStoryVideoPlayable(video)) {
              const playPromise = video.play();

              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => syncStoryVideoVisibility(video, false));
              }
            }
          }
        }

        queueStoryVideoFrameMonitor(video);
      };

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(() => tick());
        return;
      }

      window.setTimeout(tick, 240);
    };

    const playStoryVideo = async (video) => {
      if (!isStoryVideoPlayable(video) || video.dataset.productWhiskerStoryPreparing === 'true') return;

      video.dataset.productWhiskerStoryPreparing = 'true';
      syncStoryVideoVisibility(video, false);

      try {
        const clipStart = await findStoryVideoVisibleStart(video);

        if (!isStoryVideoPlayable(video) || clipStart === null) return;

        await seekStoryVideo(video, clipStart);

        const playPromise = video.play();

        if (playPromise && typeof playPromise.then === 'function') {
          await playPromise;
        }

        queueStoryVideoFrameMonitor(video);
      } catch (error) {
        syncStoryVideoVisibility(video, false);
      } finally {
        video.dataset.productWhiskerStoryPreparing = 'false';
      }
    };

    const storyVideoPreloadObserver =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;

                if (entry.isIntersecting) {
                  loadStoryVideo(video, false);
                }
              });
            },
            { rootMargin: '640px 0px', threshold: 0 }
          )
        : null;

    const storyVideoPlayObserver =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                const isInView = entry.isIntersecting && entry.intersectionRatio >= 0.32;

                video.dataset.productWhiskerStoryInView = isInView ? 'true' : 'false';

                if (isInView) {
                  playStoryVideo(video);
                } else if (!video.controls) {
                  video.pause();
                  video.dataset.productWhiskerStoryRevealPending = 'false';
                  video.dataset.productWhiskerStoryPreparing = 'false';
                  syncStoryVideoVisibility(video, false);
                }
              });
            },
            { rootMargin: '0px', threshold: [0, 0.16, 0.32, 0.6, 1] }
          )
        : null;

    const setupStoryVideos = (root = document) => {
      root.querySelectorAll('.product-whisker__story-video').forEach((video) => {
        const media = video.closest('.product-whisker__story-media');

        if (media) {
          media.classList.add('product-whisker__story-media--video');
        }

        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.preload = 'metadata';

        if (video.dataset.productWhiskerStoryVideo !== 'ready') {
          video.dataset.productWhiskerStoryVideo = 'ready';
          video.addEventListener('loadeddata', () => markStoryVideoReady(video));
          video.addEventListener('canplay', () => markStoryVideoReady(video));
          video.addEventListener('playing', () => {
            markStoryVideoReady(video);
            queueStoryVideoFrameMonitor(video);
          });
          video.addEventListener('pause', () => {
            if (!video.controls) {
              video.dataset.productWhiskerStoryRevealPending = 'false';
              syncStoryVideoVisibility(video, false);
            }
          });
          video.addEventListener('ended', () => {
            if (!video.loop) {
              syncStoryVideoVisibility(video, false);
            }
          });
        }

        if (video.controls) {
          loadStoryVideo(video);
          syncStoryVideoVisibility(video, true);
          return;
        }

        if (storyVideoPreloadObserver && storyVideoPlayObserver) {
          storyVideoPreloadObserver.observe(video);
          storyVideoPlayObserver.observe(video);
          return;
        }

        video.dataset.productWhiskerStoryInView = 'true';
        loadStoryVideo(video, false);
        playStoryVideo(video);
      });
    };

    document.querySelectorAll('.product-whisker').forEach((root) => {
      root.classList.add('product-whisker--story-videos-enhanced');
    });
    setupStoryVideos();
    window.addEventListener('pageshow', () => {
      setupDetailRails();
      setupStoryVideos();
      setupModelShowcaseWarmers();
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        setupDetailRails();
        setupStoryVideos();
        setupModelShowcaseWarmers();
      }
    });
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.closest('.product-whisker') || event.target;

      if (root && root.classList) {
        root.classList.add('product-whisker--story-videos-enhanced');
      }

      setupDetailRails(event.target);
      setupStoryVideos(event.target);
      setupModelShowcaseWarmers(event.target);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('.product-whisker') || document;

      if (root && root.classList) {
        root.classList.add('product-whisker--story-videos-enhanced');
      }

      setupDetailRails(root);
      setupStoryVideos(root);
      setupModelShowcaseWarmers(root);
    });

    const syncVideoTrigger = (trigger, isPlaying) => {
      const cinema = trigger.closest('.product-whisker__cinema');
      const label = trigger.querySelector('[data-product-whisker-video-label]');
      const playLabel = trigger.dataset.playLabel || '';
      const pauseLabel = trigger.dataset.pauseLabel || playLabel;

      trigger.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      trigger.classList.toggle('product-whisker__cinema-cta--playing', isPlaying);

      if (cinema) {
        cinema.classList.toggle('product-whisker__cinema--video-playing', isPlaying);
      }

      if (label) {
        label.textContent = isPlaying ? pauseLabel : playLabel;
      }
    };

    const enableVideoSound = (video) => {
      video.muted = false;
      video.defaultMuted = false;
      video.removeAttribute('muted');

      if (video.volume === 0) {
        video.volume = 1;
      }
    };

    document.querySelectorAll('[data-product-whisker-video-trigger]').forEach((trigger) => {
      const cinema = trigger.closest('.product-whisker__cinema');
      const video = cinema ? cinema.querySelector('.product-whisker__cinema-video') : null;

      if (!video) return;

      syncVideoTrigger(trigger, !video.paused && !video.ended);
      video.addEventListener('play', () => syncVideoTrigger(trigger, true));
      video.addEventListener('pause', () => syncVideoTrigger(trigger, false));
      video.addEventListener('ended', () => syncVideoTrigger(trigger, false));
    });

    const setModelViewerPrompt = (deferredModel, shouldPrompt) => {
      const viewer = deferredModel ? deferredModel.querySelector('model-viewer') : null;

      if (!viewer) return;

      const prompt = shouldPrompt ? 'auto' : 'none';

      viewer.setAttribute('interaction-prompt', prompt);
      viewer.interactionPrompt = prompt;

      if (shouldPrompt) {
        viewer.removeAttribute('tabindex');
        return;
      }

      viewer.setAttribute('tabindex', '-1');

      if (document.activeElement === viewer && typeof viewer.blur === 'function') {
        viewer.blur();
      }
    };

    const cleanModelViewerChrome = (viewer) => {
      if (!viewer) return;

      viewer.style.background = 'transparent';
      viewer.style.backgroundColor = 'transparent';
      viewer.style.border = '0';
      viewer.style.boxShadow = 'none';
      viewer.style.outline = '0';
      viewer.style.setProperty('--poster-color', 'transparent');

      if (viewer.hasAttribute('poster')) {
        viewer.removeAttribute('poster');
      }

      viewer.poster = '';

      if (typeof viewer.dismissPoster === 'function') {
        viewer.dismissPoster();
      }

      if (!viewer.shadowRoot || viewer.shadowRoot.querySelector('[data-product-whisker-model-shadow-cleanup]')) {
        return;
      }

      const style = document.createElement('style');
      style.setAttribute('data-product-whisker-model-shadow-cleanup', 'true');
      style.textContent = `
        [part="default-progress-bar"],
        [part="default-progress-mask"] {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }

        .slot.poster,
        #default-poster {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }

        .slot.canvas,
        canvas {
          background: transparent !important;
        }
      `;

      viewer.shadowRoot.appendChild(style);
    };

    const prepareModelViewer = (deferredModel) => {
      if (!deferredModel) return;

      const viewer = deferredModel.querySelector('model-viewer');

      if (!viewer) return;

      const markReady = () => {
        cleanModelViewerChrome(viewer);
        setModelViewerPrompt(
          deferredModel,
          deferredModel.classList.contains('product-whisker__model-deferred--viewer-visible')
        );
        deferredModel.classList.add('product-whisker__model-deferred--ready');
        deferredModel.classList.remove('product-whisker__model-deferred--loading');
      };

      viewer.style.backgroundColor = 'transparent';
      viewer.style.border = '0';
      viewer.style.boxShadow = 'none';
      viewer.style.outline = '0';
      viewer.style.setProperty('--poster-color', 'transparent');
      cleanModelViewerChrome(viewer);
      setModelViewerPrompt(
        deferredModel,
        deferredModel.classList.contains('product-whisker__model-deferred--viewer-visible')
      );
      viewer.addEventListener('load', markReady, { once: true });
      viewer.addEventListener('model-visibility', markReady, { once: true });

      if (viewer.loaded || viewer.complete) {
        markReady();
        return;
      }

      window.setTimeout(markReady, 3200);
    };

    const loadModelShowcase = (deferredModel) => {
      if (!deferredModel) return;

      const scrollLeft = window.scrollX;
      const scrollTop = window.scrollY;

      if (!deferredModel.hasAttribute('loaded')) {
        deferredModel.classList.add('product-whisker__model-deferred--loading');

        if (typeof deferredModel.loadContent !== 'function') {
          const loadAttempts = Number(deferredModel.dataset.productWhiskerModelLoadAttempts || 0);

          if (loadAttempts < 20) {
            deferredModel.dataset.productWhiskerModelLoadAttempts = String(loadAttempts + 1);
            window.setTimeout(() => loadModelShowcase(deferredModel), 180);
            return;
          }

          deferredModel.classList.remove('product-whisker__model-deferred--loading');
          return;
        }

        deferredModel.loadContent(false);

        window.requestAnimationFrame(() => {
          window.scrollTo({
            left: scrollLeft,
            top: scrollTop,
            behavior: 'auto',
          });

          const viewer = deferredModel.querySelector('model-viewer');

          if (viewer && !deferredModel.classList.contains('product-whisker__model-deferred--viewer-visible')) {
            viewer.blur();
          }
        });
      }

      window.requestAnimationFrame(() => prepareModelViewer(deferredModel));
    };

    const setupModelShowcaseWarmers = (scope = document) => {
      if (!scope.querySelectorAll) return;

      scope.querySelectorAll('.product-whisker__model-showcase').forEach((showcase) => {
        const deferredModel = showcase.querySelector('.product-whisker__model-deferred');

        if (!deferredModel || deferredModel.dataset.productWhiskerModelWarmed === 'true') return;

        deferredModel.dataset.productWhiskerModelWarmed = 'true';

        const warmModel = () => loadModelShowcase(deferredModel);

        if (navigator.connection && navigator.connection.saveData) {
          return;
        }

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmModel, { timeout: 4500 });
        } else {
          window.setTimeout(warmModel, 2600);
        }

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries, currentObserver) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                warmModel();
                currentObserver.unobserve(showcase);
              });
            },
            { rootMargin: '420px 0px' }
          );

          observer.observe(showcase);
          return;
        }

        window.setTimeout(warmModel, 1200);
      });
    };

    setupModelShowcaseWarmers();

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-product-whisker-gallery-input]');

      if (!input) return;

      const gallery = input.closest('[data-product-whisker-gallery]');

      if (!gallery) return;

      syncGalleryState(gallery, input, { scrollThumb: true });
    });

    document.addEventListener('click', (event) => {
      const modelTrigger = event.target.closest('[data-product-whisker-model-trigger]');

      if (modelTrigger) {
        const selector = modelTrigger.dataset.productWhiskerModelTrigger;
        const activeLabel = modelTrigger.dataset.productWhiskerModelActiveLabel;
        const poster = selector ? document.querySelector(selector) : null;
        const showcase = modelTrigger.closest('.product-whisker__model-showcase');
        const stage = showcase ? showcase.querySelector('[data-product-whisker-model-stage]') : null;
        const deferredModel = stage ? stage.querySelector('.product-whisker__model-deferred') : null;
        const modelActive = showcase
          ? showcase.classList.contains('product-whisker__model-showcase--active')
          : false;

        if (modelActive) {
          const viewer = showcase.querySelector('model-viewer');

          event.preventDefault();
          modelTrigger.setAttribute('aria-pressed', 'true');
          modelTrigger.setAttribute('aria-disabled', 'true');
          modelTrigger.disabled = true;

          if (viewer && typeof viewer.focus === 'function') {
            viewer.focus({ preventScroll: true });
          }

          return;
        }

        if (!poster && !deferredModel) return;

        event.preventDefault();

        if (deferredModel) {
          deferredModel.classList.add('product-whisker__model-deferred--viewer-visible');
          setModelViewerPrompt(deferredModel, true);
          loadModelShowcase(deferredModel);
        } else if (poster) {
          poster.click();
        }

        if (showcase) {
          showcase.classList.add('product-whisker__model-showcase--active');
        }

        if (stage) {
          stage.classList.add('product-whisker__model-stage--active');
        }

        if (activeLabel) {
          modelTrigger.textContent = activeLabel;
        }

        modelTrigger.setAttribute('aria-pressed', 'true');
        modelTrigger.setAttribute('aria-disabled', 'true');
        modelTrigger.disabled = true;

        return;
      }

      const videoTrigger = event.target.closest('[data-product-whisker-video-trigger]');

      if (videoTrigger) {
        const cinema = videoTrigger.closest('.product-whisker__cinema');
        const video = cinema ? cinema.querySelector('.product-whisker__cinema-video') : null;

        if (!video) return;

        event.preventDefault();

        if (video.paused || video.ended) {
          enableVideoSound(video);
          video.play().catch(() => {
            video.controls = true;
          });
        } else if (video.muted) {
          enableVideoSound(video);
        } else {
          video.pause();
        }

        return;
      }

      const control = event.target.closest('[data-product-whisker-gallery-control]');
      const thumbControl = event.target.closest('[data-product-whisker-thumb-control]');

      if (!control && !thumbControl) return;

      const gallery = (control || thumbControl).closest('[data-product-whisker-gallery]');

      if (!gallery) return;

      if (thumbControl) {
        const thumbViewport = getThumbViewport(gallery);

        if (!thumbViewport) return;

        event.preventDefault();

        const direction = thumbControl.dataset.productWhiskerThumbControl === 'previous' ? -1 : 1;
        const maxScroll = Math.max(0, thumbViewport.scrollHeight - thumbViewport.clientHeight);
        const nextTop = Math.min(maxScroll, Math.max(0, thumbViewport.scrollTop + direction * getThumbScrollStep(gallery)));

        if (Math.abs(nextTop - thumbViewport.scrollTop) < 2) return;

        pulseThumbControl(gallery, thumbControl, direction);
        thumbViewport.scrollTo({
          top: nextTop,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
        window.setTimeout(() => updateThumbnailControls(gallery), 320);

        return;
      }

      const inputs = getGalleryInputs(gallery);

      if (inputs.length < 2) return;

      event.preventDefault();

      const currentIndex = Math.max(
        inputs.findIndex((input) => input.checked),
        0
      );
      const direction =
        (control && control.dataset.productWhiskerGalleryControl === 'previous') ||
        (thumbControl && thumbControl.dataset.productWhiskerThumbControl === 'previous')
          ? -1
          : 1;
      const nextIndex = Math.min(inputs.length - 1, Math.max(0, currentIndex + direction));

      if (nextIndex === currentIndex) return;

      const nextInput = inputs[nextIndex];

      nextInput.checked = true;
      nextInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
